<template>
  <div id="PersonalCenter">
    <Title title="个人中心" />
    <header>
      <img
        :src="personData.headImage.length>0?personData.headImage[0].fullUrl : mrImage"
        alt=""
      >
      <div>
        <h4>{{ personData.name }}</h4>
        <p>{{ personData.branchName }}{{personData.dutyName  }} </p>
      </div>
    </header>
    <main>
      <van-cell-group>
        <van-cell
          title="我的二维码"
          is-link
          to="code"
          size="large"
        />
        <van-cell
          title="我的资料"
          is-link
          size="large"
          to="MyInformation"
        />
        <van-cell
          title="党员活动证"
          is-link
          size="large"
          value="89积分"
        />
        <van-cell
          title="党费缴纳"
          is-link
          size="large"
          to="payFor"
        />
        <!-- <van-cell
          title="党员评级"
          is-link
          size="large"
        /> -->

        <van-cell
          title="关于我们"
          is-link
          to="/PersonalCenter/aboutUs"
          size="large"
        />

        <!-- <van-cell
          title="问题反馈"
          is-link
          size="large"
        />
        <van-cell
          title="设置"
          is-link
          size="large"
        /> -->
      </van-cell-group>
    </main>
    <Footer active="grzx" />
  </div>
</template>

<script>
import Footer from '../../compents/footer.vue'
import mrImage from '../../assets/images/mrtx.png'
import Title from '../../compents/title.vue'


export default {
  name: "",

  components: {
    Footer, Title
  },
  data () {
    return {
      personData: {
        headImage: []
      },
      mrImage: mrImage
    };
  },
  mounted () {
    this.$post('/api/wl-party-web-manager/my/myData').then(res => {
      this.personData = { ...res.data }
    })
  }


};
</script>

<style lang="less">
#PersonalCenter {
  width: 100%;
  height: 100%;
  background: #fff;
  // padding: 20px 0;
  header {
    width: 100%;
    margin: 20px 0;
    padding-left: 17px;
    display: flex;
    // align-items: unset;
    img {
      width: 80px;
      height: 80px;
      border-radius: 10px;
    }
    div {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      height: 80px;
      justify-content: space-between;
      h4 {
        font-weight: 700;
        color: #333333;
        font-size: 24px;
      }
      p {
        color: #555555;
        font-size: 16px;
      }
    }
  }
  main {
    width: 100%;
    margin-top: 20px;
    // border-bottom: 1px solid #aaa !important;
    // border-top: 1px solid #aaa !important;
  }
}
.van-cell::after {
  border-bottom: 1px solid #aaa !important;
}

.mail-list-container {
  background: #fff;
  // height: 600px;
  height: calc(100% - 55px);
  // min-height: calc(100% + 1px);
  overflow-y: auto;
  display: flex;
}

.mail-list-aside {
  flex: 1;
  border-right: 1px solid #eee;
}

.mail-list-main {
  flex: 1;
}

.mail-list-panel {
  display: flex;
  flex-direction: column;
  min-height: 400px;
  max-height: 100%;
  width: 100%;
}

.mail-list-panel_full {
  height: 100%;
}

.mail-list-panel-hd {
  padding: 16px;
}

.mail-list-panel-bd {
  flex: 1;
  overflow: auto;
}

.mail-list-panel-ft {
  padding: 24px 32px;
}

.list-cell {
  display: flex;
  align-items: center;
  min-height: 46px;
  padding: 8px 16px;
  &:hover {
    background: #eee;
  }
}

.list-cell.el-checkbox {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
}

.list-cell__icon {
  margin-right: 10px;
}

.mail-list-crumb__item {
  .el-breadcrumb__inner {
    color: #303133;

    &:hover {
      color: #2f9aff;
      cursor: pointer;
    }
  }

  &:last-child {
    .el-breadcrumb__inner {
      font-weight: normal;
      color: #c0c4cc !important;

      &:hover {
        color: inherit;
        cursor: not-allowed !important;
      }
    }
  }
}

.selected-user {
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
}

.selected-user__item {
  margin-right: 8px;
  margin-bottom: 8px;
  cursor: pointer;
}

.name {
  text-overflow: ellipsis;
  overflow: hidden;
}

.addr {
  font-size: 12px;
  color: #b4b4b4;
}

.inline-input {
  width: 100%;
}
.search-result {
  height: 500px;
  overflow-y: auto;
}
</style>
